<template>
  <div class="store-goods-display">
    <span class="store-goods-list">
      {{ displayText }}
    </span>
    <el-button v-if="showEdit" type="primary" size="mini" @click="showDialog"
      >编辑</el-button
    >

    <!-- 门店商品管理弹窗 -->
    <el-dialog title="门店商品管理" :visible.sync="dialogVisible" width="800px">
      <div class="store-goods-content">
        <div class="search-section">
          <el-form :model="searchForm" inline>
            <el-form-item label="机型">
              <el-select
                v-model="searchForm.model"
                placeholder="请选择机型"
                clearable
                size="small"
                style="width: 200px"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.enumCode"
                  :label="item.enumText"
                  :value="item.enumCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="searchStoreGoods"
                >搜索</el-button
              >
              <el-button size="small" @click="resetSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="list-section">
          <el-table
            ref="storeGoodsTable"
            :data="storeGoodsList"
            style="width: 100%"
          >
            <el-table-column label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox
                  :value="isSelected(scope.row)"
                  @change="toggleSelection(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column
              prop="modelName"
              label="机型"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="memoryName"
              label="内存"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="colorNames"
              label="颜色"
              min-width="120"
            ></el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="total, prev, pager, next"
            style="margin-top: 20px; text-align: center"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveStoreGoods" size="small"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getListByIdsAPI,
  getListAPI as getStoreGoodsListAPI,
  getAttrListAPI,
} from "@/views/store/goods/api";

export default {
  name: "StoreGoodsDisplay",
  props: {
    hits: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] }, // v-model
    showEdit: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        model: "",
      },
      storeGoodsList: [],
      modelList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      selectedStoreGoods: [],
    };
  },
  computed: {
    displayText() {
      if (!this.value || this.value.length === 0) {
        return "暂无门店商品";
      }

      return this.value.map((item) => item.label).join("，");
    },
  },
  watch: {
    hits: {
      immediate: true,
      handler(newHits) {
        if (newHits && newHits.length > 0) {
          this.loadGoodsDetails(newHits);
        } else {
          this.$emit("input", []);
        }
      },
    },
  },
  methods: {
    async loadGoodsDetails(hits) {
      try {
        const params = {
          idList: hits.join(","),
        };
        const res = await getListByIdsAPI(params);
        const goodsList = res || [];

        // 生成elData并更新value
        const elData = goodsList.map((item) => ({
          value: item.id.toString(),
          label: `${item.modelName} ${item.memoryName}`,
        }));
        console.log(elData);
        this.$emit("input", elData);
      } catch (error) {
        console.error("查询商品详情失败:", error);
        this.$emit("input", []);
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.searchForm.model = "";
      this.storeGoodsList = [];
      this.pagination.currentPage = 1;
      this.selectedStoreGoods = [];

      // 从value字段初始化已选择的商品
      if (this.value && this.value.length > 0) {
        this.selectedStoreGoods = [...this.value];
      }

      // 打开弹窗时立即请求接口
      this.searchStoreGoods();
      this.getModelList();
    },
    async searchStoreGoods() {
      const params = {
        goodsType: 1, // 3C商品类型
        model: this.searchForm.model,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      const res = await getStoreGoodsListAPI(params);
      this.storeGoodsList = res.list || [];
      this.pagination.total = res.total || 0;
    },
    resetSearch() {
      this.searchForm.model = "";
      this.pagination.currentPage = 1;
      // 不清空选择状态，保持已选择的商品
      this.searchStoreGoods();
    },
    isSelected(row) {
      return this.selectedStoreGoods.some(
        (item) => item.value === row.id.toString(),
      );
    },
    toggleSelection(row) {
      const id = row.id.toString();
      const index = this.selectedStoreGoods.findIndex(
        (item) => item.value === id,
      );

      if (index > -1) {
        // 取消选择
        this.selectedStoreGoods.splice(index, 1);
      } else {
        // 添加选择
        this.selectedStoreGoods.push({
          value: id,
          label: `${row.modelName} ${row.memoryName}`,
        });
      }
    },
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.searchStoreGoods();
    },
    async getModelList() {
      const params = {
        goodsType: 1,
        groupCode: "model",
      };
      const res = await getAttrListAPI(params);
      this.modelList = res || [];
    },
    async saveStoreGoods() {
      // 更新value
      const newValue = [];
      this.selectedStoreGoods.forEach((item) => {
        newValue.push(item);
      });

      // 触发更新事件
      this.$emit("input", newValue);

      this.dialogVisible = false;
      this.$message.success("门店商品管理保存成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.store-goods-display {
  display: flex;
  align-items: center;
  flex: 1;
  .store-goods-list {
    flex: 1;
    margin-right: 10px;
    width: 0px;
  }
}

.store-goods-content {
  .search-section {
    margin-bottom: 20px;
    .el-form {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .list-section {
    .el-table {
      .el-table__header {
        th {
          background-color: #f5f5f5;
          color: #1a1e25;
        }
      }
      .el-checkbox {
        margin: 0;
      }
    }
  }
}
</style>
